import { HTMLProps } from 'react';
import { ModalScreenInvestment } from '../../../general/ModalScreen';
import { ForecastEmailMeCard } from './ForecastEmailMeCard';

export const EmailMeModal: React.FC<
    {
        isShown: boolean;
        onClose: () => void;
        setIsEmailSent?: (isEmailSent: boolean) => void;
    } & HTMLProps<HTMLDivElement>
> = ({ isShown, onClose, setIsEmailSent, className }) => {
    return (
        <ModalScreenInvestment isShown={isShown}>
            <div className="relative h-full w-full flex items-center text-base leading-normal text-left text-bnd-black justify-center mx-auto max-w-screen-sm">
                <ForecastEmailMeCard className={className} onClose={onClose} setIsEmailSent={setIsEmailSent} />
            </div>
        </ModalScreenInvestment>
    );
};
